'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
//	Stores form field values and validations
var Store = function Store(defaultValues, valuesObserver, validationsObserver) {
	var me = {
		values: {},
		validations: {},
		fieldRefs: {},
		setFieldRef: function setFieldRef(ref) {
			var name = ref.props && ref.props.name;
			var arrayIndex = ref.props && ref.props.arrayIndex;
			if (name) {
				if (arrayIndex !== undefined) {
					me.fieldRefs[name] = me.fieldRefs[name] || [];
					me.fieldRefs[name][arrayIndex] = ref;
				} else {
					me.fieldRefs[name] = ref;
				}
			}
		},
		deleteFieldRef: function deleteFieldRef(ref) {
			var name = ref.props && ref.props.name;
			var arrayIndex = ref.props && ref.props.arrayIndex;
			if (name) {
				if (arrayIndex !== undefined) {
					delete me.fieldRefs[name][arrayIndex];
					if (!me.fieldRefs[name].length) {
						delete me.fieldRefs[name];
					}
				} else {
					delete me.fieldRefs[name];
				}
			}
		},

		//	Clear the store - optionally skip the observer
		clear: function clear(skipObserver) {
			me.values = {};
			if (!skipObserver && valuesObserver) {
				valuesObserver(me.values);
			}
		},

		//	Sets a value - or merge an object's values
		set: function set(key, value, arrayIndex) {
			if ((typeof key === 'undefined' ? 'undefined' : (0, _typeof3.default)(key)) === 'object') {
				for (var i in key) {
					if (key.hasOwnProperty(i)) {
						me.values[i] = key[i];
					}
				}
			} else {
				if (arrayIndex !== undefined) {
					me.values[key] = me.values[key] || [];
					me.values[key][arrayIndex] = value;
				} else {
					me.values[key] = value;
				}
			}
			if (valuesObserver) {
				valuesObserver(me.values);
			}
		},

		//	Gets a value, or array index
		get: function get(key, arrayIndex, allowEmpty) {
			var value = key ? me.values[key] : me.values;
			if (arrayIndex !== undefined) {
				value = value[arrayIndex];
			}
			//	Ensure we don't get the dreaded:
			//	"...is changing a controlled input of type text to be uncontrolled." warning.
			//	TODO: Make this configurable
			return value !== undefined ? value : allowEmpty ? value : '';
		},

		//	Binders for setting the value - use for onChange events that are outside of the
		//	field, such as RadioButtonGroup in material-ui
		setBinder: function setBinder(name) {
			return function (e, value) {
				var setValue = e !== undefined && e.target && e.target.value ? e.target.value : value;
				setValue = setValue !== undefined ? setValue : '';
				me.set(name, setValue);
			};
		},
		getBinder: function getBinder(name) {
			return function () {
				return me.get(name);
			};
		},


		//	Validations
		setValidations: function setValidations(validations) {
			(0, _keys2.default)(validations).forEach(function (key) {
				return me.validations[key] = validations[key];
			});
			if (validationsObserver) {
				var validationResult = (0, _keys2.default)(me.validations).every(function (key) {
					return !me.validations[key];
				});
				validationsObserver(me.validations, validationResult);
			}
		},
		setValidation: function setValidation(key, value) {
			me.validations[key] = value;
			if (validationsObserver) {
				var validationResult = (0, _keys2.default)(me.validations).every(function (key) {
					return !me.validations[key];
				});
				validationsObserver(me.validations, validationResult);
			}
		},
		getValidation: function getValidation(key) {
			return me.validations[key];
		}
	};

	if (defaultValues) {
		me.set(defaultValues);
	}

	return me;
};

var _default = Store;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(Store, 'Store', 'src/store.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/store.js');
}();

;


// WEBPACK FOOTER //
// /Users/david/Source/react-formality/lib/store.js